import React from 'react';
import { handleLogin } from '../Navbar/Navbar.component';

function PaymentDeclined() {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f4f4f9',
      color: '#d9534f',
      fontSize: '24px',
      fontFamily: 'Arial, sans-serif',
    },
    message: {
      display: 'flex',
      flexDirection: 'column',
      background: 'white',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      textAlign: 'center',
      width: 'fit-content',
      margin: 'auto',
    },
    icon: {
      fontSize: '48px',
      marginBottom: '10px',
    },
    homeButton: {
      position: 'absolute',
      top: '20px',
      left: '20px',
      padding: '10px 20px',
      fontSize: '16px',
      backgroundColor: '#6938F2',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    }
  };

  return (
    <div style={styles.container}>
      <button style={styles.homeButton} onClick={handleLogin}>
        <i className="fas fa-arrow-left"></i> Home
      </button>
      <div style={styles.message}>
        <i style={styles.icon} className="fas fa-times-circle"></i> {/* FontAwesome icon */}
        Your payment was declined.
      </div>
    </div>
  );
}

export default PaymentDeclined;
